import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import LocaleModel from 'coreClasses/locales/LocaleModel';
import {IEcommerceData} from '../../IGoogleTagManager';
import ECommerceEventModel from './EcommerceEventModel';
import EcommerceProductLineItemModel from './models/EcommerceProductLineItemModel';
import {DATALAYER_CONFIGS} from 'brandConstants';

/**
 * Represents ECommerceProductAddToCartEventModel
 */
export default class ECommerceProductAddToCartEventModel extends ECommerceEventModel {
	public ecommerce: IEcommerceData;
	public productSku?: string;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		const currentLocale: LocaleModel = this.managerRepository.getLocalesMgr().getCurrentLocale();
		const activeTabId = localStorage.getItem('activeTabId');

		this.ecommerce = {
			currencyCode: currentLocale.getCurrencyCode(),
			add: {
				actionField: {
					list: this.getSource()
				},
				products: [
					{...new EcommerceProductLineItemModel(this.managerRepository, data.productData, data.productItem)}
				]
			}
		};

		if (activeTabId) {
			this.ecommerce.activeTabId = activeTabId;
		}

		if (DATALAYER_CONFIGS.addProductSku) {
			this.productSku = data.productItem.productId;
		}
	}
};
